import React, { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

// Pages Component
import Chat from "../pages/Chat/Chat";

// Pages File Manager
import FileManager from "../pages/FileManager/index";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

// User profile
import UserProfile from "../pages/Authentication/UserProfile";

//Tasks
import TasksList from "../pages/Tasks/tasks-list";
import TasksKanban from "../pages/Tasks/tasks-kanban";
import TasksCreate from "../pages/Tasks/tasks-create";

//Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";
import ProjectsCreate from "../pages/Projects/projects-create";

//Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
// import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

// Authentication related pages
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Register = lazy(() => import("../pages/Authentication/Register"));
const ForgetPwd = lazy(() => import("../pages/Authentication/ForgetPassword"));
//import Login from "../pages/Authentication/Login";
// import Logout from "../pages/Authentication/Logout";
// import Register from "../pages/Authentication/Register";
// import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPwd2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
const Dashboard = lazy(() => import("../pages/Dashboard/index"));
const DashboardHR = lazy(() => import("../pages/DashboardHR/index"));
const HODDashboard = lazy(() => import("../pages/HODDashboard/index"));
const DashboardSaas = lazy(() => import("../pages/Dashboard-saas/index"));
const DashboardCrypto = lazy(() => import("../pages/Dashboard-crypto/index"));
const DashboardBlog = lazy(() => import("../pages/Dashboard-blog/index"));
const DashboardEmployee = lazy(() => import("pages/DashboardEmployee/index"));
const PayrollDashboard = lazy(() => import("pages/PayrollDashboard/index"));

// import Dashboard from "../pages/Dashboard/index";
// import DashboardHR from "../pages/DashboardHR/index";
// import HODDashboard from "../pages/HODDashboard/index";
// import DashboardSaas from "../pages/Dashboard-saas/index";
// import DashboardCrypto from "../pages/Dashboard-crypto/index";
// import DashboardBlog from "../pages/Dashboard-blog/index";
// import DashboardEmployee from "pages/DashboardEmployee/index";
// import PayrollDashboard from "pages/PayrollDashboard/index";

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet";
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell";
import CryptoExchange from "../pages/Crypto/crypto-exchange";
import CryptoLending from "../pages/Crypto/crypto-lending";
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders";
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application";
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartistChart from "../pages/Charts/ChartistChart";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";
import MapsLeaflet from "../pages/Maps/MapsLeaflet";

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";
import DragDropTables from "../pages/Tables/DragDropTables";
import PrimeDataTable from "../pages/Tables/PrimeDataTable";

// Forms
import FormElements from "../pages/Forms/FormElements/index";
import FormLayouts from "../pages/Forms/FormLayouts";
// import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";
import DualListbox from "../pages/Forms/DualListbox";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiToast from "../pages/Ui/UiToast";
import UiOffCanvas from "../pages/Ui/UiOffCanvas";
import Breadcrumb from "../pages/Ui/UiBreadcrumb";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

//Blog
import BlogList from "../pages/Blog/BlogList/index";
import BlogGrid from "../pages/Blog/BlogGrid/index";
import BlogDetails from "../pages/Blog/BlogDetails";

import Roles from "../pages/Roles/index";
import RolesAccessRights from "../pages/RolesAccessRights/index";
import ManageModule from "../pages/Module/index"
import Category from "pages/Setup/Category";
import Department from "pages/Setup/Department";
import Designation from "pages/Setup/Designation";
import Qualifications from "pages/Setup/Qualifications";
import Unit from "pages/Setup/Unit";
import Holiday from "pages/Setup/Holiday";
import Leave from "pages/Setup/Leave";
import Shift from "pages/Setup/Shift";
import Setup from "pages/Configuration/Setup";
import LoginCreation from "pages/Configuration/LoginCreation";
import EmployeeDetails from "pages/Employee/EmployeeDetails";
import ChangePassword from "pages/Configuration/ChangePassword";
import EmployeeExemption from "pages/Employee/EmployeeExemption";
import EmployeeResignation from "pages/Employee/EmployeeResignation";
import MyProfile from "pages/Employee/MyProfile";
import Circular from "pages/Employee/Circular";
import LeavePolicy from "pages/Employee/PolicySetup/LeavePolicy";
import PermissionPolicy from "pages/Employee/PolicySetup/PermissionPolicy";
import GracePolicy from "pages/Employee/PolicySetup/GracePolicy";
import ShiftGroup from "pages/Setup/ShiftGroup";
import MultiLevelApproval from "pages/Employee/EmployeeOrganizational/MultilevelApproval";
import OrganizationChart from "pages/Employee/EmployeeOrganizational/OrganizationalChart";
import MasterHeads from "pages/Reimbursement/Master/Heads";
import MasterSubHeads from "pages/Reimbursement/Master/SubHeads";
import MasterMapping from "pages/Reimbursement/Master/Mapping";
import TransactionClaim from "pages/Reimbursement/Transactions/Claim";
import TransactionClaimApproval from "pages/Reimbursement/Transactions/ClaimApproval";
import Reports from "pages/Reimbursement/Reports";

//commmon
import unAuthorizedPage from "components/Common/unAuthorizedPage";
import BiometricDiscrepancy from "pages/Attendance/Biometric/Discrepancy";
import BiometricMobilePunch from "pages/Attendance/Biometric/MobilePunch";
import BiometricImportPunchList from "pages/Attendance/Biometric/ImportPunchList";
import KeysResponsibilities from "pages/Recruitment/Job Setup/KeysResponsibilities";
import Qualification from "pages/Recruitment/Job Setup/Qualifications";
import PositionCreation from "pages/Recruitment/Job Setup/PositionCreation";
import SkillMapping from "pages/Recruitment/Job Setup/SkillMapping";
import Approval from "pages/Attendance/LeaveManagement/Approval";
import Cancel from "pages/Attendance/LeaveManagement/Cancel";
import ApplyLeave from "pages/Attendance/LeaveManagement/Apply";
import ApplyLeaves from "pages/Attendance/LeaveManagement/Apply";
import Requisition from "pages/Recruitment/Resource/Requisition";
import ResourceApproval from "pages/Recruitment/Resource/Approval";
import ApplyJob from "pages/Recruitment/Onboarding/ApplyJob";
import OnboardingSelection from "pages/Recruitment/Onboarding/OnboardSelection";
import Process from "pages/Recruitment/Onboarding/Process";
import ShiftProcess from "pages/Attendance/ShiftManagement/ShiftProcess";
import ShiftChange from "pages/Attendance/ShiftManagement/ShiftChange";
import ShiftRemoval from "pages/Attendance/ShiftManagement/ShiftRemoval";
import AbsentList from "pages/Attendance/LeaveManagement/AbsentList";
import Claim from "pages/Attendance/LeaveManagement/ExtraDuty/Claim";
import ClaimApproval from "pages/Attendance/LeaveManagement/ExtraDuty/ClaimApproval";
import ClaimCancel from "pages/Attendance/LeaveManagement/ExtraDuty/ClaimCancel";
import PaymentClaim from "pages/Attendance/LeaveManagement/ExtraDuty/ClaimPayment";
import PaymentApproval from "pages/Attendance/LeaveManagement/ExtraDuty/PaymentApproval";
import PaymentCancel from "pages/Attendance/LeaveManagement/ExtraDuty/PaymentCancel";
import TimeDeductionShiftLate from "pages/Attendance/Biometric/TimeDeduction/ShiftLate";
import TimeDeductionShiftLateCancel from "pages/Attendance/Biometric/TimeDeduction/ShiftLateCancel";
import ShiftLateReport from "pages/Attendance/Biometric/TimeDeduction/ShiftLateReport";
import ShiftLateConsolidatedReport from "pages/Attendance/Biometric/TimeDeduction/ShiftLateConsolReport";
import SalaryDefinition from "pages/Payroll/Salary/SalaryDefinition";
import SalaryGeneration from "pages/Payroll/Salary/SalaryGeneration";
import StopPayment from "pages/Payroll/Salary/StopPayment";
import ExtraPayment from "pages/Payroll/Salary/ExtraPayment";
import DeductionTax from "pages/Payroll/Deduction/Tax";
import FixedDeductions from "pages/Payroll/Deduction/FixedDeductions";
import Allowance from "pages/Payroll/Salary/Allowance";
import MonthlyDeductions from "pages/Payroll/Deduction/MonthlyDeductions";
import EmployeeCreation from "pages/Employee/EmployeeDetails/create";

// Suspense Wrapper for Lazy Loading
const SuspenseWrapper = (Component) => (
  <Suspense fallback={<div style={{color:"black"}}>Loading...</div>}>
    <Component />
  </Suspense>
);
import SettlementTable from "pages/Payroll/Deduction/Settlement";
import IncrementUpdate from "pages/Payroll/Increment/IncrementUpdate";
import IncrementApproval from "pages/Payroll/Increment/IncrementApproval";
import IncrementReport from "pages/Payroll/Increment/IncrementReport";
import EmployeeIncrementReport from "pages/Payroll/Increment/EmpIncrementReport";
import PayrollAllowances from "pages/Payroll/Setup/Allowances";
import PayrollDeductions from "pages/Payroll/Setup/Deductions";
import PayrollSalarySetup from "pages/Payroll/Setup/Salary Setup";
import PayrollApplyLoan from "pages/Payroll/EmployeeLoan/LoanApply";
import PayrollCreateLoan from "pages/Payroll/EmployeeLoan/LoanApply/create";
import PayrollLoanPreClose from "pages/Payroll/EmployeeLoan/LoanPreClose/index";
import PayrollLoanFreeze from "pages/Payroll/EmployeeLoan/LoanFreeze";
import PayrollLoanApproval from "pages/Payroll/EmployeeLoan/LoanApproval";
import HolidayProcess from "pages/Setup/HolidayProcess";
import HolidayRemove from "pages/Setup/HolidayRemove";
import SelfAppraisal from "pages/Performance/SelfAppraisal";
import ManagerAppraisal from "pages/Performance/ManagerAppraisal";
import KPIFactor from "pages/Performance/KPIFactor";
import KRAFactor from "pages/Performance/KRAFactor";
import KRAKPIMapping from "pages/Performance/KRAKPIMapping";
import YearlySlabFixing from "pages/Performance/YearlyFixing";
import TimeSheetClient from "pages/TimeSheet/Setup/Client";
import TimeSheetService from "pages/TimeSheet/Setup/Service";
import TimeSheetProject from "pages/TimeSheet/Setup/Project";
import TimeSheetModule from "pages/TimeSheet/Setup/Module";
import TimeSheetTask from "pages/TimeSheet/Setup/Task";
import TimeSheetTaskType from "pages/TimeSheet/Setup/TaskType";
import TimeSheetApply from "pages/TimeSheet/Transactions/Apply";
import TimeSheetApproval from "pages/TimeSheet/Transactions/Approval";
import TimeSheetHRApproval from "pages/TimeSheet/Transactions/HRApproval";
import TimeSheetFinalApproval from "pages/TimeSheet/Transactions/FinalApproval";
import TimesheetProjectBilling from "pages/TimeSheet/Transactions/Project Billing";
import PayrollEmployeeReports from "pages/Payroll/Reports/EmployeeReports";
import PayrollMyPayslip from "pages/Payroll/Reports/MyPayslip";
import PayrollReportPayslip from "pages/Payroll/Reports/SalaryReport/MyPayslip";
import PayrollReportBankStatement from "pages/Payroll/Reports/SalaryReport/BankStatement";
import PayrollReportWagesRegister from "pages/Payroll/Reports/SalaryReport/WagesRegister";
import PayrollReportSectionWagesRegister from "pages/Payroll/Reports/SalaryReport/SectionWagesRegister";
import PayrollReportMonthlyESI from "pages/Payroll/Reports/SalaryReport/MonthlyESI";
import PayrollReportMonthlyPF from "pages/Payroll/Reports/SalaryReport/MonthlyPF";
import PayrollReportPaySummary from "pages/Payroll/Reports/SalaryReport/PayRegisterSummary";
import PayrollReportCurrentCTC from "pages/Payroll/Reports/SalaryReport/CurrentCTCReport";
import PayrollReportIndividualPay from "pages/Payroll/Reports/SalaryReport/IndividualPay";
import PayrollReportMonthlyProfTax from "pages/Payroll/Reports/SalaryReport/MonthlyProfTax";
import TimeDeductionShiftLateApproval from "pages/Attendance/Biometric/TimeDeduction/ShiftLateApproval";
import TimesheetReportMonthlyTimesheet from "pages/TimeSheet/Reports/MonthlyTimesheet";
import TimesheetReportProjectRevenue from "pages/TimeSheet/Reports/ProjectRevenue";
import TimesheetReportEmployeeDayWise from "pages/TimeSheet/Reports/EmployeeDayWise";
import TimesheetReportTaskStatus from "pages/TimeSheet/Reports/TaskStatus";
import TimesheetReportEmployeeTaskStatus from "pages/TimeSheet/Reports/EmployeeTaskStatus";
import EmployeeReportActivity from "pages/Employee/Report/Activity";
import EmployeeReportMyActivity from "pages/Employee/Report/MyActivityReport";
import EmployeeReportExemption from "pages/Employee/Report/ExemptionResigned";
import EmployeeReportAgeWise from "pages/Employee/Report/AgeWiseSearch";
import EmployeeReportBirthDay from "pages/Employee/Report/BirthDay";
import AttendanceReportConsolidate from "pages/Attendance/Reports/Attendance/Consolidate";
import AttendanceReportDayWise from "pages/Attendance/Reports/Attendance/Daywise";
import AttendanceReportMonthWise from "pages/Attendance/Reports/Attendance/MonthWise";
import AttendanceReportLateInOut from "pages/Attendance/Reports/Attendance/LateInOut";
import AttendanceReportLateComers from "pages/Attendance/Reports/Attendance/LateComers";
import AttendanceReportLateOut from "pages/Attendance/Reports/Attendance/LateOutList";
import AttendanceReportPresentDays from "pages/Attendance/Reports/Attendance/PresentDays";
import AttendanceReportOTHours from "pages/Attendance/Reports/Attendance/ExtraHourse";
import AttendanceReportChecklist from "pages/Attendance/Reports/Attendance/AttendanceChecklist";
import AttendanceReportDayWiseAbstract from "pages/Attendance/Reports/Attendance/DaywiseAbstract";
import AttendanceReportLongAbsent from "pages/Attendance/Reports/Attendance/LongAbsent";
import AttendanceReportAbsenteeism from "pages/Attendance/Reports/Attendance/Absenteeism";
import AttendanceReportMobilePunch from "pages/Attendance/Reports/Attendance/MobilePunchReport";
import AttendanceReportBreakInService from "pages/Attendance/Reports/Attendance/BreakInService";
import AttendanceReportLeave from "pages/Attendance/Reports/Leave/Leave";
import AttendanceReportPermissionOD from "pages/Attendance/Reports/Leave/PermissionOD";
import AttendanceReportLeaveBalance from "pages/Attendance/Reports/Leave/LeaveBalance";
import AttendanceReportShiftDetail from "pages/Attendance/Reports/Shift/ShiftDetail";
import AttendanceReportEmployeeShift from "pages/Attendance/Reports/Shift/EmployeeShift";
import AttendanceReportShiftLog from "pages/Attendance/Reports/Shift/ShiftLog";
import AttendanceReportForm6 from "pages/Attendance/Reports/Statutory/Form6";
import AttendanceReportForm34 from "pages/Attendance/Reports/Statutory/Form34";
import AttendanceReportForm25_26 from "pages/Attendance/Reports/Statutory/Form25&26";
import RecruitmentReportNewJoinee from "pages/Recruitment/Reports/NewJoinee";
import RecruitmentReportOnRoll from "pages/Recruitment/Reports/OnRoll";
import RecruitmentReportResource from "pages/Recruitment/Reports/Resource";
import EmployeeMassTransfer from "pages/Employee/EmployeeMassTransfer";
import ExpenseMasterHeads from "pages/Expenses/Master/Heads";
import ExpenseMasterSubHeads from "pages/Expenses/Master/SubHeads";
import ExpenseTransactionApproval from "pages/Expenses/Transaction/Approval";
import ExpenseTransactionEntry from "pages/Expenses/Transaction/ExpenseEntry";
import ExpenseReport from "pages/Expenses/Master/Reports";
import TimeSheetApprovalGenerate from "pages/TimeSheet/Transactions/HRApproval/generate";
import OnboardingSelectionViewApplicant from "pages/Recruitment/Onboarding/ViewApplicant/selection";
import OnboardingProcessViewApplicant from "pages/Recruitment/Onboarding/ViewApplicant/process";
import OnboardingApplyJobApprove from "pages/Recruitment/Onboarding/ApplyJobApprove";
import MyAttendance from "pages/Attendance/MyAttendance";
import ManualPunch from "pages/Attendance/Biometric/ManualPunch";
import SetupSkills from "pages/Setup/Skills";
import ProjectServiceMap from "pages/TimeSheet/Setup/ProjectServiceMap";
import CategoryMapping from "pages/Payroll/Setup/CategoryMapping";
import TripMaster from "pages/Setup/Tripmaster";
import BankMaster from "pages/Setup/BankMaster";
import EvaluationMaster from "pages/Setup/EvaluationMaster";
import ScoreMaster from "pages/Setup/ScoreMaster";


const authProtectedRoutes = [
  { path: "/dashboard", component: () => SuspenseWrapper(Dashboard) },
  { path: "/hr-dashboard", component: () => SuspenseWrapper(DashboardHR) },
  { path: "/hod-dashboard", component: () => SuspenseWrapper(HODDashboard) },
  { path: "/dashboard-saas", component: () => SuspenseWrapper(DashboardSaas) },
  { path: "/dashboard-crypto", component: () => SuspenseWrapper(DashboardCrypto) },
  { path: "/dashboard-blog", component: () => SuspenseWrapper(DashboardBlog) },
  { path: "/employee-dashboard", component: () => SuspenseWrapper(DashboardEmployee) },
  { path: "/payroll-dashboard", component: () => SuspenseWrapper(PayrollDashboard) },

  //Crypto
  { path: "/crypto-wallet", component: CryptoWallet },
  { path: "/crypto-buy-sell", component: CryptoBuySell },
  { path: "/crypto-exchange", component: CryptoExchange },
  { path: "/crypto-lending", component: CryptoLending },
  { path: "/crypto-orders", component: CryptoOrders },
  { path: "/crypto-kyc-application", component: CryptoKYCApplication },

  //profile
  { path: "/profile", component: UserProfile },

  //chat
  { path: "/chat", component: Chat },

  //File Manager
  { path: "/apps-filemanager", component: FileManager },

  //calendar
  { path: "/calendar", component: Calendar },

  //Ecommerce
  // { path: "/ecommerce-products/:id", component: EcommerceProducts },
  { path: "/ecommerce-products", component: EcommerceProducts },
  { path: "/ecommerce-product-details/:id", component: EcommerceProductDetail },

  { path: "/ecommerce-orders", component: EcommerceOrders },
  { path: "/ecommerce-customers", component: EcommerceCustomers },
  { path: "/ecommerce-cart", component: EcommerceCart },
  { path: "/ecommerce-checkout", component: EcommerceCheckout },
  { path: "/ecommerce-shops", component: EcommerceShops },
  { path: "/ecommerce-add-product", component: EcommerceAddProduct },

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },
  { path: "/email-template-basic", component: EmailBasicTemplte },
  { path: "/email-template-alert", component: EmailAlertTemplte },
  // { path: "/email-template-billing", component: EmailTemplateBilling },

  //Invoices
  { path: "/invoices-list", component: InvoicesList },
  { path: "/invoices-detail", component: InvoiceDetail },
  { path: "/invoices-detail/:id", component: InvoiceDetail },

  // Tasks
  { path: "/tasks-list", component: TasksList },
  { path: "/tasks-kanban", component: TasksKanban },
  { path: "/tasks-create", component: TasksCreate },

  //Projects
  { path: "/projects-grid", component: ProjectsGrid },
  { path: "/projects-list", component: ProjectsList },
  { path: "/projects-overview", component: ProjectsOverview },
  { path: "/projects-overview/:id", component: ProjectsOverview },
  { path: "/projects-create", component: ProjectsCreate },

  // Contacts
  { path: "/contacts-grid", component: ContactsGrid },
  { path: "/contacts-list", component: ContactsList },
  { path: "/contacts-profile", component: ContactsProfile },

  //Blog
  { path: "/blog-list", component: BlogList },
  { path: "/blog-grid", component: BlogGrid },
  { path: "/blog-details", component: BlogDetails },

  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/charts-knob", component: ChartsKnob },
  { path: "/re-charts", component: ReCharts },

  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  { path: "/tables-basic", component: BasicTables },
  { path: "/tables-datatable", component: DatatableTables },
  { path: "/tables-responsive", component: ResponsiveTables },
  { path: "/tables-editable", component: EditableTables },
  { path: "/tables-dragndrop", component: DragDropTables },
  { path: "/tables-prime", component: PrimeDataTable },

  // Maps
  { path: "/maps-google", component: MapsGoogle },
  { path: "/maps-vector", component: MapsVector },
  { path: "/maps-leaflet", component: MapsLeaflet },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-layouts", component: FormLayouts },
  // { path: "/form-advanced", component: FormAdvanced },
  { path: "/form-editors", component: FormEditors },
  { path: "/form-mask", component: FormMask },
  { path: "/form-repeater", component: FormRepeater },
  { path: "/form-uploads", component: FormUpload },
  { path: "/form-wizard", component: FormWizard },
  { path: "/form-validation", component: FormValidations },
  { path: "/form-xeditable", component: FormXeditable },
  { path: "/dual-listbox", component: DualListbox },

  // Ui
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-colors", component: UiColors },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-general", component: UiGeneral },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModal },
  { path: "/ui-progressbars", component: UiProgressbar },
  { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-session-timeout", component: UiSessionTimeout },
  { path: "/ui-rating", component: UiRating },
  { path: "/ui-rangeslider", component: UiRangeSlider },
  { path: "/ui-notifications", component: UiNotifications },
  { path: "/ui-toasts", component: UiToast },
  { path: "/ui-offcanvas", component: UiOffCanvas },
  { path: "/ui-breadcrumb", component: Breadcrumb },
  { path: "/ui-placeholders", component: UiPlaceholders },
  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },
  { path: "/pages-pricing", component: PagesPricing },

  { path: "/manage-roles", component: Roles },
  { path: "/roles-access-rights", component: RolesAccessRights },
  { path: "/manage-modules", component: ManageModule },
  { path: "/setup-category", component: Category },
  { path: "/setup-department", component: Department },
  { path: "/setup-designation", component: Designation },
  { path: "/setup-qualifications", component: Qualifications },
  { path: "/setup-unit", component: Unit },
  { path: "/setup-holiday", component: Holiday },
  { path: "/setup-leave", component: Leave },
  { path: "/setup-shift", component: Shift },
  { path: "/setup-shift-group", component: ShiftGroup },
  { path: "/config-setup", component: Setup },
  { path: "/config-login-creation", component: LoginCreation },
  { path: "/manage-employee", component: EmployeeDetails },
  { path: "/employee-details", component:  EmployeeCreation},
  { path: "/config-change-password", component:  ChangePassword},
  { path: "/employee-exemption", component:  EmployeeExemption},
  { path: "/employee-resignation", component:  EmployeeResignation},
  { path: "/my-profile", component: MyProfile },
  { path: "/my-profile/:id", component: MyProfile },
  { path: "/view-profile", component: MyProfile },
  { path: "/employee-circular", component: Circular },
  { path: "/leave-policy", component: LeavePolicy },
  { path: "/permission-policy", component: PermissionPolicy },
  { path: "/grace-policy", component: GracePolicy },
  { path: "/multilevel-approval", component: MultiLevelApproval },
  { path: "/organization-chart", component: OrganizationChart },
  { path: "/reimb-master-heads", component: MasterHeads },
  { path: "/reimb-master-subheads", component: MasterSubHeads },
  { path: "/reimb-master-mapping", component: MasterMapping },
  { path: "/reimb-master-mapping", component: MasterMapping },
  { path: "/reimb-txns-claim", component: TransactionClaim },
  { path: "/reimb-txns-ca", component: TransactionClaimApproval },
  { path: "/reimb-reports", component: Reports },
  { path: "/reports", component: Reports },
  { path: "/attnd-bio-discrepancy", component:  BiometricDiscrepancy},
  { path: "/attnd-bio-mobile-punch", component:  BiometricMobilePunch},
  { path: "/attnd-bio-imp-punch", component:  BiometricImportPunchList},
  { path: "/rcrt-job-set-key-resps", component: KeysResponsibilities },
  { path: "/rcrt-job-set-qual", component:  Qualification},
  { path: "/rcrt-job-set-poscr", component:  PositionCreation},
  { path: "/rcrt-job-set-skill-map", component:  SkillMapping},
  { path: "/attnd-leave-approval", component:  Approval},
  { path: "/attnd-leave-cancel", component:  Cancel},
  { path: "/attnd-leave-apply", component:  ApplyLeaves},
  { path: "/attnd-leave-absentlist", component:  AbsentList},
  { path: "/attnd-leave-extra-claim", component:  Claim},
  { path: "/attnd-leave-extra-claim-approval", component:  ClaimApproval},
  { path: "/attnd-leave-extra-claim-cancel", component:  ClaimCancel},
  { path: "/attnd-leave-extra-claim-payment", component:  PaymentClaim},
  { path: "/attnd-leave-extra-claim-payment-approval", component:  PaymentApproval},
  { path: "/attnd-leave-extra-claim-payment-cancel", component:  PaymentCancel},

  { path: "/payroll-salary-definition", component:  SalaryDefinition},
  { path: "/payroll-salary-generation", component:  SalaryGeneration},
  { path: "/payroll-salary-stop-payment", component:  StopPayment},
  { path: "/payroll-salary-extra-payment", component:  ExtraPayment},
  { path: "/payroll-salary-allowance", component:  Allowance},
  { path: "/category-mapping",component:CategoryMapping},


  { path: "/rcrt-resource-requisition", component:  Requisition},
  { path: "/rcrt-resource-approval", component:  ResourceApproval},
  { path: "/rcrt-onbd-app-job", component:  ApplyJob},
  { path: "/rcrt-onbd-selection", component:  OnboardingSelection},
  { path: "/rcrt-onbd-process", component:  Process},
  { path: "/rcrt-onbd-view-appl-selection", component:  OnboardingSelectionViewApplicant},
  { path: "/rcrt-onbd-view-appl-process", component:  OnboardingProcessViewApplicant},
  { path: "/attnd-shift-process", component:  ShiftProcess},
  { path: "/attnd-shift-change", component:  ShiftChange},
  { path: "/attnd-shift-removal", component:  ShiftRemoval},
  { path: "/time-deductions-shift-late", component:  TimeDeductionShiftLate},
  { path: "/time-deductions-late-approval", component: TimeDeductionShiftLateApproval},
  { path: "/shift-late-cancel", component:  TimeDeductionShiftLateCancel},
  { path: "/shift-late-report", component:  ShiftLateReport},
  { path: "/shift-late-consol-report", component:  ShiftLateConsolidatedReport},
  { path: "/payroll-ded-tax", component:  DeductionTax},
  { path: "/payroll-fixed-deductions", component:  FixedDeductions},
  { path: "/payroll-monthly-deductions", component: MonthlyDeductions},
  { path: "/payroll-settlement", component: SettlementTable},
  { path: "/payroll-increment-update", component: IncrementUpdate},
  { path: "/payroll-increment-approval", component: IncrementApproval},
  { path: "/payroll-increment-report", component: IncrementReport},
  { path: "/payroll-emp-increment-report", component: EmployeeIncrementReport},
  { path: "/payroll-allowance", component: PayrollAllowances},
  { path: "/payroll-deduction", component: PayrollDeductions},
  { path: "/payroll-salary-setup", component: PayrollSalarySetup},
  { path: "/payroll-loan-apply", component: PayrollApplyLoan},
  { path: "/payroll-create-loan", component: PayrollCreateLoan},
  { path: "/payroll-loan-pre-close", component: PayrollLoanPreClose},
  { path: "/payroll-loan-freeze", component: PayrollLoanFreeze},
  { path: "/payroll-loan-approval", component: PayrollLoanApproval},
  { path: "/holiday-process", component: HolidayProcess},
  { path: "/holiday-remove", component: HolidayRemove},
  { path: "/perfor-self-appraisal", component: SelfAppraisal},
  { path: "/perfor-manager-appraisal", component: ManagerAppraisal},
  { path: "/perfor-kpi-factor", component: KPIFactor},
  { path: "/perfor-kra-factor", component: KRAFactor},
  { path: "/perfor-kra-kpi-mapping", component: KRAKPIMapping},
  { path: "/perfor-yearly-fixing", component: YearlySlabFixing},
  { path: "/time-setup-client", component: TimeSheetClient},
  { path: "/time-setup-service", component: TimeSheetService},
  { path: "/time-setup-project", component: TimeSheetProject},
  { path: "/time-setup-module", component: TimeSheetModule},
  { path: "/time-setup-task", component: TimeSheetTask},
  { path: "/time-setup-tasktype", component: TimeSheetTaskType},
  { path: "/time-trans-apply", component: TimeSheetApply},
  { path: "/time-trans-approval", component: TimeSheetApproval},
  { path: "/time-trans-hr-appr", component: TimeSheetHRApproval},
  { path: "/time-trans-final-appr", component: TimeSheetFinalApproval},
  { path: "/time-project-bill-report", component: TimesheetProjectBilling},
  { path: "/payroll-employee-report", component: PayrollEmployeeReports},
  { path: "/payroll-my-payslip", component: PayrollMyPayslip},
  { path: "/payroll-pay-slip", component: PayrollReportPayslip},
  { path: "/payroll-bank-statement", component: PayrollReportBankStatement},
  { path: "/payroll-wages-register", component: PayrollReportWagesRegister},
  { path: "/payroll-sec-wages-register", component: PayrollReportSectionWagesRegister},
  { path: "/payroll-esi-register", component: PayrollReportMonthlyESI},
  { path: "/payroll-pf-register", component: PayrollReportMonthlyPF},
  { path: "/payroll-pay-register", component: PayrollReportPaySummary},
  { path: "/payroll-current-ctc-report", component: PayrollReportCurrentCTC},
  { path: "/payroll-individual-pay-register", component: PayrollReportIndividualPay},
  { path: "/payroll-mon-prof-tax-register", component: PayrollReportMonthlyProfTax},
  { path: "/time-reports-monthly-timesheet", component: TimesheetReportMonthlyTimesheet},
  { path: "/time-reports-project-revenue", component: TimesheetReportProjectRevenue},
  { path: "/time-reports-emp-day-wise", component: TimesheetReportEmployeeDayWise},
  { path: "/time-reports-task-status", component: TimesheetReportTaskStatus},
  { path: "/time-reports-emp-task-status", component: TimesheetReportEmployeeTaskStatus},
  { path: "/employee-report-activity", component: EmployeeReportActivity},
  { path: "/employee-report-my-activity", component: EmployeeReportMyActivity},
  { path: "/employee-report-exemption", component: EmployeeReportExemption},
  { path: "/employee-report-age-wise", component: EmployeeReportAgeWise},
  { path: "/employee-report-birthday", component: EmployeeReportBirthDay},
  { path: "/attnd-report-consolidate", component: AttendanceReportConsolidate},
  { path: "/attnd-report-day-wise", component: AttendanceReportDayWise},
  { path: "/attnd-report-month-wise", component: AttendanceReportMonthWise},
  { path: "/attnd-report-lateinout", component: AttendanceReportLateInOut},
  { path: "/attnd-report-late-comers", component: AttendanceReportLateComers},
  { path: "/attnd-report-late-out", component: AttendanceReportLateOut},
  { path: "/attnd-report-present-days", component: AttendanceReportPresentDays},
  { path: "/attnd-report-extra-hourse", component: AttendanceReportOTHours},
  { path: "/attnd-report-checklist", component: AttendanceReportChecklist},
  { path: "/attnd-report-day-abstract", component: AttendanceReportDayWiseAbstract},
  { path: "/attnd-report-absenteeism", component: AttendanceReportAbsenteeism},
  { path: "/attnd-report-long-absent", component: AttendanceReportLongAbsent},
  { path: "/attnd-report-mobile-punch", component: AttendanceReportMobilePunch},
  { path: "/attnd-report-break-in-service", component: AttendanceReportBreakInService},
  { path: "/attnd-report-leave", component: AttendanceReportLeave},
  { path: "/attnd-report-permission-od", component: AttendanceReportPermissionOD},
  { path: "/attnd-report-leave-balance", component: AttendanceReportLeaveBalance},
  { path: "/attnd-report-shift-details", component: AttendanceReportShiftDetail},
  { path: "/attnd-report-employee-shift", component: AttendanceReportEmployeeShift},
  { path: "/attnd-report-shift-log", component: AttendanceReportShiftLog},
  { path: "/attnd-report-form-6", component: AttendanceReportForm6},
  { path: "/attnd-report-form-34", component: AttendanceReportForm34},
  { path: "/attnd-report-form-25-26", component: AttendanceReportForm25_26},
  { path: "/rcrt-report-new-joinee", component: RecruitmentReportNewJoinee},
  { path: "/rcrt-report-resource", component: RecruitmentReportResource},
  { path: "/rcrt-report-on-roll", component: RecruitmentReportOnRoll},
  { path: "/employee-mass-transfer", component: EmployeeMassTransfer},
  { path: "/expenses-master-heads", component: ExpenseMasterHeads},
  { path: "/expenses-master-sub-heads", component: ExpenseMasterSubHeads},
  { path: "/expenses-trans-entry", component: ExpenseTransactionEntry},
  { path: "/expenses-trans-Approval", component: ExpenseTransactionApproval},
  { path: "/expenses-report", component: ExpenseReport},
  { path: "/time-hr-approval-generate", component: TimeSheetApprovalGenerate},
  { path: "/rcrt-onbd-app-job-approve", component:  OnboardingApplyJobApprove},
  { path: "/my-attendance", component:  MyAttendance},
  { path: "/my-attendance/:id", component:  MyAttendance},
  { path: "/attnd-bio-manual-punch", component:  ManualPunch},
  { path: "/setup-skills", component: SetupSkills },
  { path: "/time-setup-projectservicemap", component: ProjectServiceMap },
  { path: "/tripmaster", component: TripMaster },
  { path: "/bankmaster", component: BankMaster },
  { path: "/evaluationmaster", component: EvaluationMaster },
  { path: "/scoremaster", component: ScoreMaster },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: () => SuspenseWrapper(Logout) },
  { path: "/login", component: () => SuspenseWrapper(Login) },
  { path: "/forgot-password", component: () => SuspenseWrapper(ForgetPwd) },
  { path: "/register", component: () => SuspenseWrapper(Register) },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/crypto-ico-landing", component: CryptoIcoLanding },

  { path: "/unAuthorized", component: unAuthorizedPage },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-login-2", component: Login2 },

  { path: "/pages-register", component: Register1 },
  { path: "/pages-register-2", component: Register2 },

  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/pages-recoverpw-2", component: Recoverpw2 },

  { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  { path: "/pages-forgot-pwd-2", component: ForgetPwd2 },

  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/auth-lock-screen-2", component: LockScreen2 },
  { path: "/page-confirm-mail", component: ConfirmMail },
  { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  { path: "/auth-email-verification", component: EmailVerification },
  { path: "/auth-email-verification-2", component: EmailVerification2 },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-verification-2", component: TwostepVerification2 },
];

export { authProtectedRoutes, publicRoutes };